import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { dataDisplayStyles as styles } from './DataDisplay';

interface RawDataPanelProps {
  currentMatch: any;
}

const RawDataPanel: React.FC<RawDataPanelProps> = ({ currentMatch }) => {
  const [prettyView, setPrettyView] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    toast.success('클립보드에 복사되었음.');
  };

  return (
    <>
      <div style={styles.rawDataControls}>
        <label style={styles.toggleLabel}>
          <input
            type="checkbox"
            checked={prettyView}
            onChange={(e) => setPrettyView(e.target.checked)}
            style={styles.checkbox}
          />
          Pretty View
        </label>
        <button
          style={styles.rawDataCopyButton}
          onClick={() => copyToClipboard(JSON.stringify((() => {
            const { predictions, ...matchData } = currentMatch;
            return matchData;
          })(), null, prettyView ? 2 : 0))}
          title="원본 데이터 복사"
        >
          복사
        </button>
      </div>
      <div style={styles.rawDataContainer}>
        <div style={styles.rawData}>
          <pre style={styles.pre}>
            {JSON.stringify((() => {
              // Exclude predictions from raw data
              const { predictions, ...matchData } = currentMatch;
              return matchData;
            })(), null, prettyView ? 2 : 0)}
          </pre>
        </div>
      </div>
    </>
  );
};

export default RawDataPanel;
